import { render, staticRenderFns } from "./CreatePersonInfo.vue?vue&type=template&id=629ed414&"
import script from "./CreatePersonInfo.vue?vue&type=script&lang=js&"
export * from "./CreatePersonInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports